import React, {useState, useEffect} from "react";
import RecordDataComponent from "./RecordDataComponent";
import {SaveRecordingData} from "../helpers/SaveRecordingData";

//Used for recording pages pronunciation, translation flash cards, and dialog flash cards
function RecordDataWrapper(
    {
        assignmentNum,
        classLevel,
        page,
        startQuiz,
        stopQuiz,
        handleStartQuiz,
        handleStopQuiz,
        updateAssignmentNames
    }
) {

    const [toggleRecording, setToggleRecording] = useState(false);
    const [blob, setBlob] = useState(new Blob);
    const [record, setRecord] = useState(false);
    const [blobURL, setBlobURL] = useState('');
    //Open used for modal
    const [open, setOpen] = useState(false);
    const [success, setSuccess] = useState(false)

    useEffect(()=>{
        setTimeout(()=>{
            setSuccess(false)
        },5000)
    },[success])

    const startRecording = () => {
        setRecord(true);
        setBlobURL('')
        setBlob(new Blob)
    };

    const stopRecording = () => {
        setRecord(false);
    };

    const onData = (recordedBlob) => {
        console.log('chunk of real-time data is: ', recordedBlob);
    };

    const onStop = (recordedBlob) => {
        setBlobURL(recordedBlob.blobURL);
        setBlob(recordedBlob)
    };

    const handleToggleRecording = () => {
        setToggleRecording(prevState => !prevState)
    };

    const handleSaveRecording = () => {
        SaveRecordingData(classLevel, page, blob, assignmentNum).then((res)=>{
            setSuccess(res);
            updateAssignmentNames();
        })
    };



    return (
        <RecordDataComponent
            toggleRecording={toggleRecording}
            record={record}
            onStop={onStop}
            onData={onData}
            blobURL={blobURL}
            handleSaveRecording={handleSaveRecording}
            startQuiz={startQuiz}
            setOpen={setOpen}
            open={open}
            stopRecording={stopRecording}
            startRecording={startRecording}
            handleStartQuiz={handleStartQuiz}
            handleToggleRecording={handleToggleRecording}
            handleStopQuiz={handleStopQuiz}
            success={success}
        />
    )
}

export default RecordDataWrapper
